import * as types from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  error: false,
  display: true,
  topicTreeSelection: undefined,
  topicTreeSelectionL1: undefined,
  topicTreeSelectionL2: undefined,
  topicTreeSelectionL3: undefined,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_TOPIC_TREE:
      return Object.assign({}, state, { isLoading: true });
    case types.RECEIVE_TOPIC_TREE_ERROR:
      return Object.assign({}, state, { isLoading: false, error: true });
    case types.RECEIVE_TOPIC_TREE_RESPONSE:
      return Object.assign({}, state, { isLoading: false, error: false, topicTreeSelection: action.payload });
    case types.SELECT_TOPIC_L1:
      return Object.assign({}, state, { isLoading: false, error: false, topicTreeSelectionL1: action.payload });
    case types.SELECT_TOPIC_L1_RESET:
      return Object.assign({}, state, { isLoading: false, error: false, topicTreeSelectionL1: undefined, topicTreeSelectionL2: undefined, topicTreeSelectionL3: undefined });
    case types.SELECT_TOPIC_L2:
      return Object.assign({}, state, { isLoading: false, error: false, topicTreeSelectionL2: action.payload });
    case types.SELECT_TOPIC_L2_RESET:
      return Object.assign({}, state, { isLoading: false, error: false, topicTreeSelectionL2: undefined, topicTreeSelectionL3: undefined });
    case types.SELECT_TOPIC_L3:
      return Object.assign({}, state, { isLoading: false, error: false, topicTreeSelectionL3: action.payload });
    case types.REQUEST_CALLUS :
    case types.REQUEST_BY_EMAIL:
    case types.RECEIVE_EMPTY_FIELDS:
      return Object.assign({}, state, { display: false });
    case types.CHANGE_TOPIC:
    case types.CANCEL_EMAIL_FORM:
    case types.CANCEL_EMAIL_FORM_NO_INTENT:
      return Object.assign({}, state, { display: true });
    default:
      return state;
  }
}
